import React, { useEffect, useState } from "react";
import axios from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";

export default function AdminAssignedOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const loadData = async () => {
    try {
      const res = await axios.get("admin/assigned-orders/");
      setOrders(res.data.orders || []);
    } catch {
      alert("Failed to load assigned orders");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  if (loading) return <p style={{ padding: 20 }}>Loading...</p>;

  return (
    <div style={{ padding: 20 }}>
      <h2>🚚 Assigned Orders (Live Tracking)</h2>

      {orders.length === 0 && <p>No active deliveries</p>}

      {orders.map((o) => (
        <div
          key={o.id}
          style={{
            border: "1px solid #ddd",
            padding: 15,
            borderRadius: 8,
            marginBottom: 15,
          }}
        >
          <h4>Order #{o.id}</h4>

          <p><b>Customer:</b> {o.customer_name} ({o.phone})</p>
          <p><b>Payment:</b> {o.payment_method.toUpperCase()}</p>
          <p><b>Type:</b> {o.order_type.toUpperCase()}</p>

          {o.hospital_name && (
            <p><b>Hospital:</b> {o.hospital_name}</p>
          )}

          <p><b>Order Amount:</b> ₹{o.order_amount}</p>
          <p><b>Delivery Charge:</b> ₹{o.delivery_charge}</p>

          <p>
            <b>Delivery Boy:</b> {o.delivery_boy.name} ({o.delivery_boy.phone})
          </p>

          <button
            onClick={() => navigate(`/admin/live-map/${o.id}`)}
            style={{
              padding: "8px 12px",
              background: "#2563eb",
              color: "#fff",
              border: "none",
              borderRadius: 6,
              cursor: "pointer",
            }}
          >
            View Live Map
          </button>
        </div>
      ))}
    </div>
  );
}
